// ---- urls && window navigation
export const navigate = url =>
  typeof window !== 'undefined' && window.location.assign(url);
